let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("28SkP")).then(() => parcelRequire('35tAX'));